export type ImportRunStatus =
	| "PENDING"
	| "RUNNING"
	| "COMPLETED"
	| "FAILED"
	| (string & NonNullable<unknown>)

export const runHeadline = (status: ImportRunStatus): string => {
	if (status === "COMPLETED") return "Import finished"
	if (status === "FAILED") return "Import stopped"
	return "Importing"
}

export const runIsWorking = (status: ImportRunStatus): boolean =>
	status !== "COMPLETED" && status !== "FAILED"

/**
 * Three dots fading in turn, so a run that writes nothing for a minute still
 * reads as alive. The row keeps its width whatever the dots do.
 */
export function WorkingDots() {
	return (
		<span
			aria-hidden
			className="ml-1.5 inline-flex w-5 flex-none justify-between align-middle"
		>
			{[0, 200, 400].map((delay) => (
				<span
					key={delay}
					className="h-1 w-1 animate-pulse rounded-full bg-current"
					style={{ animationDelay: `${delay}ms` }}
				/>
			))}
		</span>
	)
}
